// extracted by mini-css-extract-plugin
export default {"root":"rM7ckN","resetDesignAttributes":"YJEKQk","bg":"InKIFF","css-background":"YAf4Ti","cssBackground":"YAf4Ti"};